import React from 'react'

import { Button, Row, Space } from 'antd'
import { SyncOutlined } from '@ant-design/icons'

import VendorFinances from '../../../../components/job/finance/vendor'

const CustomTasksFinances = (props) => {
  return (
    <>
      <Row justify='end'>
        <Space style={{ padding: 10 }}>
          {props.allowEdit && (
            <Button
              size='small'
              icon={<SyncOutlined />}
              onClick={() => props.updatePrices(props.id)}
              disabled={props.actionLoading}
            >
              Prices
            </Button>
          )}
        </Space>
      </Row>

      <VendorFinances {...props} vendor />
    </>
  )
}

export default CustomTasksFinances
